var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Predloha"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M49.439 60.083v15.309M148.625 60.083v15.309M150.882 9.734H46.941c-8.177 0-14.806 6.629-14.806 14.806v150.675c0 8.177 6.629 14.806 14.806 14.806h103.941c8.177 0 14.806-6.629 14.806-14.806V24.54c0-8.177-6.629-14.806-14.806-14.806zM54.691 33.093h88.663v25.689H54.691V33.093zm22.903 135.04h-23v-23h23v23zm0-33.592h-23v-23h23v23zm0-32.858h-23v-23h23v23zm32.736 66.45h-23v-23h23v23zm0-33.592h-23v-23h23v23zm0-32.98h-23v-23h23v23zm33.103 66.572h-23v-23h23v23zm0-33.592h-23v-23h23v23zm0-32.98h-23v-23h23v23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.1e006313a9dfd74ea0f558df52df8cd0.svg";
export { ForwardRef as ReactComponent };